<template>
  <section class="default-container">
    <BreadCrumb :bread-crumb="breadCrumb" />
    <div class="content">
      <div class="content-left">
        <div class="left-title">HR 자료</div>
        <div class="menu-wrap">
          <div v-for="(menu, index) in menuList" :key="'menu' + index" class="menu-item">
            <div :class="['menu-name', {on: menu.selected}]" @click="menuClick(index)">{{ menu.name }}</div>
            <div v-show="menu.subMenuShow" class="sub-menu__wrap">
              <div
                v-for="(subMenu, idx) in menu.subMenu"
                :key="'subMenu' + idx"
                :class="['sub-menu__item', {on: subMenu.selected}]"
                @click="subMenuClick(index, idx)"
              >
                ・ {{ subMenu.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div v-if="menuList[2].selected === true" class="keyword">
          <div class="member-korean__nav">
            <div
              v-for="(item, index) in koreanNavItems"
              :key="'korNav' + index"
              :class="['nav-item', {on: item.selected}]"
              @click="changeConsonant(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="search-wrap">
            <input
              type="text"
              :value="keywordSearchInfo.keyword"
              @input="inputKeywordSearchData($event)"
              placeholder="검색"
              @keyup.enter="getHrKeywordList"
            />
            <search-icon class="search-icon" @click="getHrKeywordList" />
          </div>
          <div class="keyword-list">
            <div v-for="keyword in keywordList" :key="'key' + keyword.id" :class="['keyword-item', {on: keyword.show}]">
              <div class="keyword-title" @click="keyword.show = !keyword.show">
                <div class="title-wrap">
                  <div class="consonant is-14r">{{ keyword.consonant }}</div>
                  <div class="title is-14m">{{ keyword.title }}</div>
                </div>
                <toggle-arrow-icon :on="keyword.show" />
              </div>
              <div v-show="keyword.show" class="keyword-content">{{ keyword.content }}</div>
            </div>
          </div>
          <pagination
            :total-count="keywordSearchInfo.totalCount"
            :now-page="keywordSearchInfo.page"
            :limit="keywordSearchInfo.limit"
            @changePage="keywordListChangePage"
          />
        </div>
        <div v-else class="hr-list">
          <div v-if="menuList[0].selected === true" class="data-type__wrap">
            <div
              v-for="(dataType, idx) in dataTypeList"
              :key="'dataType' + idx"
              :class="['data-type__item', {on: dataType.selected}]"
              @click="dataTypeClick(dataType)"
            >
              {{ dataType.name }}
            </div>
          </div>
          <PropertyRightBtn class="right-btn" />
          <div class="search-wrap">
            <input type="text" :value="hrSearchInfo.keyword" @input="inputSearchData($event)" placeholder="검색" @keyup.enter="getHrDataBoardList" />
            <search-icon class="search-icon" @click="getHrDataBoardListKeyword" />
          </div>
          <div class="list-wrap">
            <div class="list-top">
              <div class="top-item type">분류</div>
              <div class="top-item title">제목</div>
              <div class="top-item">형식</div>
              <div class="top-item">등급</div>
            </div>
            <div class="list-item__wrap">
              <div v-for="(hr, idx) in hrList" :key="'hr' + idx" class="list-item" @click="goDetail(hr.id)">
                <div class="item-type">{{ hr.dataTypeName }}</div>
                <div class="item-title">
                  <div class="title">{{ hr.title }}</div>
                  <div class="sub-title">{{ hr.subtitle }}</div>
                </div>
                <div class="item">
                  <small-pdf-icon />
                </div>
                <div :class="['rate', 'item', {paid: hr.isPaid}]">
                  {{ hr.isPaid === 1 ? '유료' : '무료' }}
                </div>
              </div>
            </div>
            <pagination
              :total-count="hrSearchInfo.totalCount"
              :now-page="hrSearchInfo.page"
              :limit="hrSearchInfo.limit"
              @changePage="hrListChangePage"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BreadCrumb from '~/components/common/BreadCrumb.vue'
import {useHrStore} from '~/store/hr/index.js'
import {useMemberStore} from '~/store/member/index.js'
import {comma} from '~/utils/function.js'
import SearchIcon from 'assets/svg/search-icon.vue'
import SmallPdfIcon from 'assets/svg/small-pdf-icon.vue'
import Pagination from '~/components/common/Pagination.vue'
import ToggleArrowIcon from 'assets/svg/toggle-arrow-icon.vue'
import PropertyRightBtn from '~/components/common/PropertyRightBtn.vue'
import {useHead} from '#imports'

export default {
  name: 'HrIndex',
  components: {PropertyRightBtn, Pagination, SmallPdfIcon, SearchIcon, BreadCrumb, ToggleArrowIcon},
  setup() {
    const store = useHrStore()
    const memberStore = useMemberStore()
    // 사이트 링크용 메타 태그 설정
    useHead({
      title: 'HR 자료  | 한국인사관리협회',
      meta: [
        {
          name: 'description',
          content: '한국인사관리협회 HR 자료실에서 인사관리규정, 연봉조사자료, HR 용어 등 HR 전문가를 위한 최신 자료를 찾아보세요.'
        },
        {
          property: 'og:title', // Open Graph 태그 (카카오톡, 페이스북 등 공유 시 미리보기 제목)
          content: 'HR 자료  | 한국인사관리협회'
        },
        {
          property: 'og:description', // Open Graph 태그 (공유 시 미리보기 설명)
          content: '한국인사관리협회 HR 자료실에서 인사관리규정, 연봉조사자료, HR 용어 등 HR 전문가를 위한 최신 자료를 찾아보세요.'
        }
      ],
      // 쿼리 파라미터가 붙더라도 항상 이 URL이 표준임을 알립니다.
      link: [
        { rel: 'canonical', href: 'https://insabank.com/hr' }
      ]
    })
    return {store, memberStore}
  },
  data() {
    return {
      isAuth: false,
      breadCrumb: [],
      comma,
      menuList: [
        {
          name: '인사관리규정',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: '인사관리규정', selected: false}]
        },
        {
          name: '연봉조사자료',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: '연봉조사자료', selected: false}]
        },
        {
          name: 'HR용어',
          selected: false,
          subMenuShow: false,
          subMenu: [
            {name: '인사∙조직부문', selected: false},
            {name: '노무∙노사부문', selected: false},
            {name: '인재개발부문', selected: false}
          ]
        }
      ],
      dataTypeList: [
        {
          id: '',
          name: '',
          selected: false
        }
      ],
      dataTypeCounter: 0,
      hrList: [
        {
          id: 0,
          type: '',
          dataType: '',
          dataTypeName: '',
          title: '',
          subtitle: '',
          introduction: '',
          tableOfContents: null,
          previewImgPath: null,
          pageCount: null,
          isPaid: 1,
          price: 0
        }
      ],
      hrSearchInfo: {
        // 타입 ( 01: 인사관리규정, 02: 연봉조사자료 )
        type: '01',
        limit: 20,
        keyword: '',
        dataType: '',
        totalCount: 0,
        page: 1
      },
      keywordList: [
        {
          id: 0,
          consonant: '',
          title: '',
          content: ''
        }
      ],
      keywordSearchInfo: {
        // 용어 타입 (01: 인사,조직부문, 02: 노무,노사 부문, 03: 인재개발부문)
        type: '01',
        limit: 20,
        keyword: '',
        totalCount: 0,
        page: 1,
        consonant: ''
      },
      koreanNavItems: [
        {name: '전체', selected: true},
        {name: '가', selected: false},
        {name: '나', selected: false},
        {name: '다', selected: false},
        {name: '라', selected: false},
        {name: '마', selected: false},
        {name: '바', selected: false},
        {name: '사', selected: false},
        {name: '아', selected: false},
        {name: '자', selected: false},
        {name: '차', selected: false},
        {name: '카', selected: false},
        {name: '타', selected: false},
        {name: '파', selected: false},
        {name: '하', selected: false},
        {name: 'A', selected: false},
        {name: 'B', selected: false},
        {name: 'C', selected: false},
        {name: 'D', selected: false},
        {name: 'E', selected: false},
        {name: 'F', selected: false},
        {name: 'G', selected: false},
        {name: 'H', selected: false},
        {name: 'I', selected: false},
        {name: 'J', selected: false},
        {name: 'K', selected: false},
        {name: 'L', selected: false},
        {name: 'M', selected: false},
        {name: 'N', selected: false},
        {name: 'O', selected: false},
        {name: 'P', selected: false},
        {name: 'Q', selected: false},
        {name: 'R', selected: false},
        {name: 'S', selected: false},
        {name: 'T', selected: false},
        {name: 'U', selected: false},
        {name: 'V', selected: false},
        {name: 'W', selected: false},
        {name: 'X', selected: false},
        {name: 'Y', selected: false},
        {name: 'Z', selected: false}
      ]
    }
  },
  watch: {
    $route: {
      handler: function () {
        this.menuController()
      },
      deep: true
    }
  },
  async mounted() {
    this.isAuth = this.memberStore.isAuthenticated
    this.menuController()
    await this.checkQueryCode()
  },
  methods: {
    async checkQueryCode() {
      // 쿼리스트링에서 code값이 있는지 체크
      const hrDataCode = this.$route.query.code
      const keyword = this.$route.query.keyword
      const page = this.$route.query.page
      if (hrDataCode) {
        await this.getHrDataBoardList()
        const selectedDataType = this.dataTypeList.find(dt => dt.id === hrDataCode)
        if (selectedDataType) {
          await this.dataTypeClick(selectedDataType)
        }
      }
      this.hrSearchInfo.keyword = keyword ? keyword : ''
      this.hrSearchInfo.page = page ? parseInt(page) : 1
    },
    // 상세보기로 이동
    goDetail(id) {
      if (!this.isAuth) {
        alert('로그인 후 이용해주세요.')
        return
      }

      this.$router.push(`/hr/${id}`)
    },
    // 가나다순 정력
    changeConsonant(item) {
      this.keywordSearchInfo.consonant = item.name
      item.selected = true
      // 나머지 아이템은 다 False
      this.koreanNavItems.forEach(navItem => {
        if (navItem.name !== item.name) {
          navItem.selected = false
        }
      })
      if (item.name === '전체') this.keywordSearchInfo.consonant = ''
      this.keywordSearchInfo.page = 1
      this.getHrKeywordList()
    },
    async getHrKeywordList() {
      try {
        const {data} = await this.store.getHrKeywordList(this.keywordSearchInfo)
        this.keywordList = data.list
        this.keywordSearchInfo.totalCount = data.count
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    },
    // 정보자료 페이지네이션 작업
    hrListChangePage(page) {
      this.hrSearchInfo.page = page
      this.getHrDataBoardList()

      // scroll top 부드럽게
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    // keyword 페이지네이션 작업
    keywordListChangePage(page) {
      this.keywordSearchInfo.page = page
      this.getHrKeywordList()

      // scroll top 부드럽게
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    inputKeywordSearchData(event) {
      this.keywordSearchInfo.keyword = event.target.value
    },
    // dataTypeClick,idx
    async dataTypeClick(dataType) {
      this.hrSearchInfo.dataType = dataType.id
      dataType.selected = true
      // 나머지 false
      this.dataTypeList.forEach(item => {
        if (item.id !== dataType.id) {
          item.selected = false
        }
      })
      this.hrSearchInfo.page = 1
      await this.getHrDataBoardList()
    },
    getHrDataBoardListKeyword() {
      this.hrSearchInfo.page = 1
      this.getHrDataBoardList()
    },
    dataController(menuIndex, subMenuIndex) {
      switch (menuIndex) {
        case 0:
          this.hrSearchInfo = {
            type: '01',
            limit: 20,
            keyword: this.$route.query.keyword ? this.$route.query.keyword : '',
            dataType: this.$route.query.code ? this.$route.query.code : '',
            totalCount: 0,
            page: this.$route.query.page ? parseInt(this.$route.query.page) : 1
          }
          if (this.$route.query.code) {
            this.dataTypeList.forEach(item => {
              if (item.id === this.$route.query.code) {
                item.selected = true
              } else {
                item.selected = false
              }
            })
          } else {
            this.dataTypeList.forEach(item => {
              item.selected = false
            })
            this.dataTypeList[0].selected = true
          }

          this.getHrDataBoardList()
          break
        case 1:
          this.hrSearchInfo = {
            type: '02',
            limit: 20,
            keyword: this.$route.query.keyword ? this.$route.query.keyword : '',
            dataType: '',
            totalCount: 0,
            page: 1
          }
          this.getHrDataBoardList()
          break
        case 2:
          if (subMenuIndex === 0) {
            this.keywordSearchInfo.type = '01'
          } else if (subMenuIndex === 1) {
            this.keywordSearchInfo.type = '02'
          } else if (subMenuIndex === 2) {
            this.keywordSearchInfo.type = '03'
          }

          this.getHrKeywordList()
          break
      }
    },
    inputSearchData(event) {
      this.hrSearchInfo.keyword = event.target.value
    },
    async getHrDataBoardList() {
      try {
        const {data} = await this.store.getHrDataBoardList(this.hrSearchInfo)
        this.hrList = data.list
        this.hrSearchInfo.totalCount = data.count

        if (this.hrSearchInfo.type === '01') {
          if (this.dataTypeCounter === 0) {
            this.dataTypeList = data.dataTypeList
            this.dataTypeCounter++
          }
        }
        this.$router.push(
          `/hr?menu=${this.$route.query.menu}&subMenu=0&code=${this.hrSearchInfo.dataType}&keyword=${this.hrSearchInfo.keyword}&page=${this.hrSearchInfo.page}`
        )
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    },
    menuController() {
      const urlParams = new URLSearchParams(window.location.search)
      const menuIndex = parseInt(urlParams.get('menu') || '0')
      const subMenuIndex = parseInt(urlParams.get('subMenu') || '0')

      // 기존 메뉴 서브메뉴는 초기화
      this.menuList.forEach(menu => {
        menu.selected = false
        menu.subMenuShow = false
        if (menu.subMenu) {
          menu.subMenu.forEach(subMenu => {
            subMenu.selected = false
          })
        }
      })

      // 선택된 메뉴와 서브메뉴의 상태 변경
      if (this.menuList[menuIndex]) {
        this.menuList[menuIndex].selected = true
        this.menuList[menuIndex].subMenuShow = true

        if (this.menuList[menuIndex].subMenu[subMenuIndex]) {
          this.menuList[menuIndex].subMenu[subMenuIndex].selected = true
        }
      }

      this.dataController(menuIndex, subMenuIndex)

      this.breadCrumbController()
    },
    breadCrumbController() {
      // 초기화
      this.breadCrumb = []

      // 기본 breadcrumb 설정
      this.breadCrumb = ['홈', 'HR 자료']

      this.menuList.forEach(menu => {
        if (menu.selected) {
          this.breadCrumb.push(menu.name)
          if (menu.subMenu) {
            menu.subMenu.forEach(subMenu => {
              if (subMenu.selected) {
                this.breadCrumb.push(subMenu.name)
              }
            })
          }
        }
      })
    },
    menuClick(index) {
      switch (index) {
        case 0:
          this.$router.push('/hr?menu=0&subMenu=0')
          break
        case 1:
          this.$router.push('/hr?menu=1&subMenu=0')
          break
        case 2:
          this.$router.push('/hr?menu=2&subMenu=0')
          break
      }

      window.scrollTo({top: 0})
    },
    subMenuClick(index, idx) {
      this.$router.push(`/hr?menu=${index}&subMenu=${idx}`)
      window.scrollTo({top: 0})
    }
  }
}
</script>

<style scoped lang="scss">
.default-container {
  padding: 48px 0 100px;
  .content {
    display: flex;
    gap: 24px;
    position: relative;
    .content-left {
      min-width: 222px;
      min-width: 222px;
      position: sticky;
      top: 40px;
      left: 0;
      height: 600px;
      .left-title {
        color: #121212;
        font-family: 'Godo', sans-serif;
        border-bottom: 1px solid #121212;
        padding-bottom: 24px;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 125%; /* 30px */
      }
      .menu-name {
        padding: 24px;
        border-bottom: 1px solid #dbdbdb;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 20px */
        cursor: pointer;
        &:hover {
          color: #0058aa;
        }
        &.on {
          font-weight: 700;
          color: #0058aa;
        }
      }
      .sub-menu__item {
        padding: 12px 24px;
        cursor: pointer;
        color: #606060;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 17.5px */
        &.on {
          font-weight: 700;
          color: #0058aa;
        }
        &:hover {
          background: #f8fbfd;
          color: #0058aa;
        }
        &:last-child {
          border-bottom: 1px solid #dbdbdb;
        }
      }
    }
    .content-right {
      width: 100%;
      .keyword {
        .member-korean__nav {
          display: flex;
          border-bottom: 1px solid #dbdbdb;
          margin-bottom: 12px;
          flex-wrap: wrap;
          margin-bottom: 16px;
          .nav-item {
            width: 47px;
            height: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #606060;
            position: relative;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            cursor: pointer;
            &:hover {
              color: #0058aa;
            }
            &.on {
              color: #0058aa;
              &::after {
                content: '';
                position: absolute;
                bottom: 0;
                left: 0;
                display: block;
                width: 100%;
                height: 3px;
                background: #0058aa;
              }
            }
          }
        }
        .keyword-list {
          margin-bottom: 32px;
          .keyword-item {
            &:hover {
              background: #fbfbfb;
            }
            &.on {
              background: #fbfbfb;
            }
            .keyword-title {
              padding: 15px 12px;
              border-bottom: 1px solid #f2f2f2;
              display: flex;
              align-items: center;
              justify-content: space-between;
              cursor: pointer;
              .title-wrap {
                display: flex;
                align-items: center;
                gap: 10px;
                .consonant {
                  display: flex;
                  padding: 1px 3px 1px 4px;
                  width: 20px;
                  height: 20px;
                  justify-content: center;
                  align-items: center;
                  border: 1px solid #dbdbdb;
                  background: #fff;
                }
              }
            }
            .keyword-content {
              padding: 24px;
              white-space: pre-line;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
            }
          }
        }
      }
      .hr-list {
        .right-btn {
          margin-bottom: 24px;
        }
        .data-type__wrap {
          display: flex;
          flex-wrap: wrap;
          gap: 4px;
          margin-bottom: 24px;
        }
        .data-type__item {
          border-radius: 4px;
          border: 1px solid #dbdbdb;
          width: 175px;
          height: 42px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #606060;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 125%; /* 17.5px */
          cursor: pointer;
          &.on {
            border: 1px solid #0058aa;
            color: #0058aa;
          }
        }
      }

      .search-wrap {
        padding: 9px;
        border-radius: 4px;
        border: 1px solid #dbdbdb;
        background: #fff;
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        input {
          border: none;
          width: 100%;
          outline: none;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 125%; /* 17.5px */
          &::placeholder {
            color: #bdbdbd;
          }
        }
        .search-icon {
          cursor: pointer;
        }
      }
      .list-wrap {
        .list-top {
          display: flex;
          border-bottom: 1px solid #909090;
          background: #fbfbfb;

          .top-item {
            padding: 12px 16px;
            width: 56px;
            color: #606060;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 125%; /* 15px */
            letter-spacing: -1px;
            &.type {
              width: 108px;
            }
            &.title {
              width: 69%;
            }
          }
        }
        .list-item__wrap {
          margin-bottom: 24px;
          .list-item {
            display: flex;
            border-bottom: 1px solid #dbdbdb;
            cursor: pointer;
            .item-type {
              width: 108px;
              color: #121212;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 125%; /* 15px */
              letter-spacing: -0.2px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .item-title {
              width: 69%;
              padding: 16px;
              .title {
                color: #121212;
                font-size: 14px;
                font-style: normal;
                font-weight: 600;
                line-height: 125%; /* 17.5px */
                letter-spacing: -0.2px;
                margin-bottom: 4px;
              }
              .sub-title {
                color: #212121;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 125%; /* 15px */
                letter-spacing: -0.2px;
              }
            }
            .item {
              padding: 16px;
              width: 56px;
              display: flex;
              align-items: center;
              justify-content: center;

              &.rate {
                color: #0058aa;
                background: rgba(0, 88, 170, 0.05);
                text-align: center;
                font-family: Pretendard;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 125%; /* 17.5px */
                letter-spacing: -0.2px;
              }

              &.paid {
                color: #e40e0e;
                background: rgba(228, 14, 14, 0.05);
              }
            }
          }
        }
      }
    }
  }
}
</style>
